// Vendor
import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import { withRouter } from 'next/router';
import AnchorLink from '../../components/AnchorLink';
import { Router } from '../../routes';
// Helpers
import isLinkExternal from 'helpers/isLinkExternal';
// Hocs
// import { withTheme } from 'components/hocs/Theme';
// Styles
import './style.styl';

const isModifiedEvent = event => {
  return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
};

const AppLink = ({
  className,
  activeClassName,
  children,
  router,
  href,
  external,
  targetBlank,
  onClick,
  siteTheme,
  anchor,
  underline,
  ...props
}) => {
  const classes = cn({
    AppLink: true,
    [className]: className,
  });
  const componentProps = {
    className: classes,
    href: href,
    ...props,
  };

  const isExternal = external || isLinkExternal(href);

  if (isExternal) {
    if (targetBlank) {
      componentProps.target = '_blank';
      componentProps.rel = 'nofollow noopener';
    }
    return <a {...componentProps}>{children}</a>;
  }

  const handleClick = async e => {
    if (!anchor) {
      // onClick должен вернуть false, чтобы отменить переход
      if (onClick(e) === false) {
        e.preventDefault();
        return;
      }

      // Проверка на сброс события (взято из <Link /> react-router'a)
      if (
        !e.defaultPrevented && // onClick prevented default
        e.button === 0 && // ignore everything but left clicks
        !targetBlank && // let browser handle "target=_blank" etc.
        !isModifiedEvent(e) // ignore clicks with modifier keys
      ) {
        e.preventDefault();
        await Router.pushRoute(href);
        if (!window.location.hash) {
          window.scrollTo(0, 0);
        }
      }
    }
  };
  const TagName = anchor ? AnchorLink : 'a';

  return (
    <TagName onClick={handleClick} {...componentProps}>
      {children}
    </TagName>
  );
};

AppLink.defaultProps = {
  className: '',
  activeClassName: '',
  router: {},
  href: '/',
  external: false,
  targetBlank: false,
  anchor: false,
  onClick: () => true,
  siteTheme: '',
};

AppLink.propTypes = {
  className: PropTypes.string,
  activeClassName: PropTypes.string,
  children: PropTypes.node,
  router: PropTypes.object,
  href: PropTypes.string,
  external: PropTypes.bool,
  targetBlank: PropTypes.bool,
  anchor: PropTypes.bool,
  onClick: PropTypes.func,
};

// export default withRouter(withTheme()(AppLink));
export default withRouter(AppLink);



// WEBPACK FOOTER //
// components/AppLink/index.js